module.exports = __webpack_public_path__ + "static/media/six.23d8f77c.png";